import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { GlobalContext } from '../../providers/GlobalProvider';
import { Grid } from '@mui/material';
import ChatUI from 'components/Classify/ChatUI';

const ImportPage: React.FC = () => {
  const { cur_user, resetTicketDraft, wasTicketDraftRestored } =
    useContext(GlobalContext);
  const location = useLocation<{ resumeImportTicket?: unknown }>();
  const [userHasMonitor, setUserHasMonitor] = useState(true);

  useEffect(() => {
    checkForMonitor();
  }, []);

  useEffect(() => {
    // ticketDraft is a single app-wide slot on GlobalContext shared by every
    // Case-based tool. Without this, arriving here after saving in a
    // different tool inherits its leftover draft/_id instead of starting
    // fresh. Skip when explicitly resuming a saved import ticket, or when a
    // forced re-login redirect just restored an in-progress draft (see
    // GlobalProvider's ticketDraft / sessionRecovery.ts).
    if (!location.state?.resumeImportTicket && !wasTicketDraftRestored()) {
      resetTicketDraft();
    }
  }, []);

  const requiredTiers = ['business', 'enterprise'];

  const checkForMonitor = () => {
    if (
      !requiredTiers.includes(cur_user.license) &&
      cur_user?.bite_super_admin !== true
    ) {
      setUserHasMonitor(false);
    }
  };

  return (
    <section className='standard-workflow-page Home-HeaderDown'>
      <div className='standard-workflow-page-content'>
        <Grid container className='standard-workflow-page-grid-host'>
          <Grid item xs={12} className='standard-workflow-page-grid-item'>
            <ChatUI userHasMonitor={userHasMonitor} />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ImportPage;
